// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"_1mXhZtlcX4e9xEcCw-OLN0","modal-body":"LNpFIrGfYW13G-U5gFjUJ","buttonWrapper":"_18GfWPoZGeDGcrUb6l4XcJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ MailingAddressDetails/styles.css
// module id = 3184
// module chunks = 0